import { render, staticRenderFns } from "./PublishingFields.vue?vue&type=template&id=61eb727c&lang=pug"
import script from "./PublishingFields.vue?vue&type=script&lang=ts"
export * from "./PublishingFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports